import { InjectionToken } from '@angular/core';

/**
 * Injection token for providing the base url.
 * This is required to use the base url of the api in any library that might be
 * making request to the middleware.
 */
export const BASE_URL_TOKEN = new InjectionToken<string>('BASE_URL');
export const BASE_REPORT_URL_TOKEN = new InjectionToken<string>('BASE_REPORT_URL');
/**
 * Base URL for the isolated audit microservice (Spec #37950, AC-19).
 * Distinct from BASE_URL_TOKEN (main Raptor API) and federationApiUrl. The
 * audit microservice deploys independently and its endpoints live on a
 * separate origin, so the audit-log feature library uses this token for all
 * its HTTP calls.
 */
export const AUDIT_API_BASE_URL_TOKEN = new InjectionToken<string>('AUDIT_API_BASE_URL');
export const API_PATHS_TOKEN = new InjectionToken<{ [id: string]: string }>('API_PATHS');
